import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/setHours/index.js';

var require$$30 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$30 as default };
